import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export default new Router({
	mode: 'history',
	routes: [
		{
			//首页
			path: '/',
			name: 'Home',
			component: (resolve) => require(['@/views/Home.vue'], resolve),
		},
		{
			//首页
			path: '/contractUs',
			name: 'aboutUs',
			component: (resolve) => require(['@/views/aboutUs.vue'], resolve),
		},
		{
			//首页
			path: '/aboutUs',
			name: 'business',
			component: (resolve) => require(['@/views/business.vue'], resolve),
		},
		{
			//首页
			path: '/offers',
			name: 'offers',
			component: (resolve) => require(['@/views/offers.vue'], resolve),
		},
		{
			//首页
			path: '/offer',
			name: 'privacy',
			component: (resolve) => require(['@/views/privacy.vue'], resolve),
		},
		//cooperate
	],
})
